<template>
  <section id="about-mobile">
    <v-container fluid class="text-center mt-5">
      <!-- Simpler History Section -->
      <History />

      <!-- Core Values Section -->
      <div class="mb-5">
        <span class="font-weight-black black--text custom-font display-1">
          CORE
        </span>
        <span class="font-weight-black red--text custom-font display-1">
          VALUES
        </span>
      </div>
      <!-- CoreValues Component without Parallax -->
      <CoreValues class="my-5" />

      <!-- Partners Section -->
      <div class="mt-5">
        <span class="font-weight-black black--text display-1"> OUR </span>
        <span class="font-weight-black red--text display-1"> PARTNERS </span>
      </div>
      <!-- Partners listed in rows of 3 -->
      <v-row>
        <v-col cols="6" sm="4" v-for="(image, index) in images" :key="index">
          <v-avatar size="100" class="ma-1">
            <v-img :src="image.src" height="100%" width="100%" contain></v-img>
          </v-avatar>
        </v-col>
      </v-row>

      <!-- Certifications Section -->
      <div class="my-5">
        <span class="font-weight-black black--text display-1"> OUR </span>
        <span class="font-weight-black red--text display-1">
          CERTIFICATIONS
        </span>
      </div>
      <!-- List certifications as simpler images -->
      <v-row>
        <v-col
          cols="12"
          sm="4"
          v-for="(image, index) in certifactions"
          :key="index"
        >
          <v-avatar size="250" class="my-n8">
            <v-img :src="image.src" height="100%" width="100%" contain></v-img>
          </v-avatar>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
  
  <script>
import History from "./History";
import CoreValues from "./CoreValues.vue";

export default {
  name: "AboutMobile",
  components: {
    History,
    CoreValues,
  },
  data() {
    return {
      images: [
        { src: require("@/assets/ems_images/del.png") },
        { src: require("@/assets/ems_images/citysights.png") },
        { src: require("@/assets/ems_images/crossbridge.png") },
        { src: require("@/assets/ems_images/first_service.png") },
        { src: require("@/assets/ems_images/icc.png") },
        { src: require("@/assets/ems_images/icon_property.jpg") },
        { src: require("@/assets/ems_images/medallion.png") },
        { src: require("@/assets/ems_images/nadian.png") },
        { src: require("@/assets/ems_images/park_properties.png") },
        { src: require("@/assets/ems_images/princess.png") },
        { src: require("@/assets/ems_images/stronghold.png") },
        { src: require("@/assets/ems_images/westdalepng.png") },
        // ... any additional images
      ],
      certifactions: [
        { src: require("@/assets/ems_images/whm.png") },
        { src: require("@/assets/ems_images/acco.png") },
        { src: require("@/assets/ems_images/iicrc.png") },

        // ... any additional images
      ],
    };
  },
};
</script>
  

